import * as R from 'ramda';
import { Product } from '@inter-ikea-storageone/range';

type ProductWidthsMap = {
  [width: string]: Product[];
};

export type ProductVariants = {
  variants: Product[];
  defaults: Product[];
};

const getProp = (path: string, product: Product) => {
  return R.path(path.split('.'), product);
};

export const getAutoFillVariants = (
  products: Product[],
  productId: string,
  autoFillDefault: string[]
) => {
  const autoFillProduct = products.find(p => p.coreProductId === productId);
  const defaults = products.filter(({ coreProductId }) => autoFillDefault.includes(coreProductId));

  if (!autoFillProduct) {
    return {
      variants: [],
      defaults: []
    };
  }

  const variants = products.reduce((acc: Product[], curr: Product) => {
    const isProductVariant = ['type', 'name', 'typeName', 'design'].every(path => {
      return R.equals(getProp(path, curr), getProp(path, autoFillProduct));
    });
    if (isProductVariant) {
      return [...acc, curr];
    }
    return acc;
  }, []);

  const groupVariants = R.groupBy((p: Product) => {
    return p.dimensions.width.toString();
  });

  const groupedVariants = R.pipe<Product[], Product[], ProductWidthsMap>(
    R.filter((p: Product) => !!p.dimensions.width),
    groupVariants
  )(variants);

  const availableWidth = Object.keys(groupedVariants);
  const firstWidth = autoFillProduct.dimensions.width;

  if (!firstWidth) {
    return {
      variants: [],
      defaults: []
    };
  } // TODO: No product should have missing widths.

  const sortOrder = R.uniq([
    firstWidth,
    ...availableWidth.filter(w => w !== firstWidth.toString())
  ]);

  const variantsIds = sortOrder.flatMap(s => groupedVariants[s]);
  return {
    variants: variantsIds,
    defaults
  } as ProductVariants;
};
